import { Component, Input } from '@angular/core';
import { InitialInterviewApiService } from "../initial-interview-api.service";
import { Router } from "@angular/router";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { MatButton } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { PageService } from "../service/page-service";
import { InitialInterviewPage } from "../../../enums";
import { MatIcon } from "@angular/material/icon";
import { routeGatherToProfileOrThankYou } from "../util";
import { TalentProfileApiService } from '../../talent-profile/talent-profile-api.service';
import { VideoInterviewFlowService } from "../video-interview/service/video-interview-flow.service";

@Component({
    imports: [
        MatButton,
        TranslateModule,
        MatProgressSpinnerModule,
        MatIcon
    ],
    selector: 'app-initial-interview-no-questions-page',
    templateUrl: './initial-interview-no-questions-page.component.html',
    styleUrl: './initial-interview-no-questions-page.component.scss'
})
export class InitialInterviewNoQuestionsPageComponent {
  @Input() standardQuestionIds: number[] = [];

  constructor(private pageService: PageService,
              private initialInterviewApi: InitialInterviewApiService,
              private router: Router,
              private talentHappyPathDataService: TalentHappyPathDataService,
              private talentProfileApiService: TalentProfileApiService,
              private videoInterviewFlowService: VideoInterviewFlowService) {

  }


  clickBackButton() {
    this.pageService.setActivePage(InitialInterviewPage.QUESTIONS_PAGE);
  }

  clickSubmitButton() {
    const orderId = this.talentHappyPathDataService.postingInfo.orderId;
    const personId = this.talentHappyPathDataService.talent.personId

    if (this.standardQuestionIds.length === 0) {
      // Sending an empty list would 500.
      this.finishSubmission(personId, orderId);
      return;
    }

    this.initialInterviewApi.submitCustomQuestionAnswers(this.standardQuestionIds, orderId, personId).subscribe(result => {
      this.finishSubmission(personId, orderId);
    });
  }

  private finishSubmission(personId: number, orderId: number) {
    this.initialInterviewApi.createTalentSubmittedQuestionsActivity(personId,
                                                                    orderId,
                                                                    this.talentHappyPathDataService.postingId
                                                                   ).subscribe(() => {
      if (this.videoInterviewFlowService.shouldShowForWorkflowA()) {
        // Workflow A: video interview after the IIQ questions (only placeholder-slot questions here).
        this.videoInterviewFlowService.enterVideoInterview();
        return;
      }
      if (this.talentHappyPathDataService.gather) {
        routeGatherToProfileOrThankYou(this.talentHappyPathDataService.gather.talentPersonId,
                                       this.talentProfileApiService, this.router)
      } else {
        void this.router.navigate(['/talent-profile'], { skipLocationChange: true });
      }
    });
  }
}
